import React from 'react';

import { useStore } from '../store';

import '@awesome.me/webawesome/dist/components/avatar/avatar.js';

const UserAvatar: React.FC<{ profile?: any }> = ({ profile: userProfile }) => {
  const storeProfile = useStore((state) => state.profile);

  const profile = userProfile || storeProfile;

  return (
    <wa-avatar
      image={profile?.avatar || undefined}
      initials={profile?.initials || undefined}
      label={profile?.name}
    >
    </wa-avatar>
  );
}

export default UserAvatar;
